import React, { useEffect, useState } from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { SIGNIN, EXPIRATIONTOKEN } from './paths';
import { TOKEN, useAuthContext } from '../contexts/authContext';
import { useSelector } from 'react-redux';
import { RootState } from '../redux/store';
import { LayoutDefault } from '../components/layout/default/layoutDefault';
import BlockPagesDefault from '../components/components/views/blockPagesDefault';

type Props = {
    blockPageName?: string;
};

export default function PrivateRoute({ blockPageName }: Props) {
    const { tokenAuth, logout } = useAuthContext();
    const { expirationToken } = useSelector((state: RootState) => state.auth);
    const { blockPagesList } = useSelector((state: RootState) => state.general);
    const [checkValidate, setCheckValidate] = useState<boolean>(false);
    const [validate, setValidate] = useState<any>(undefined);

    useEffect(() => {
        if (blockPagesList.length > 0) {
            const validate =
                blockPagesList.find((row: any) => row.page === blockPageName) ||
                undefined;
            setCheckValidate(validate !== undefined);
            setValidate(validate);
        }
    }, [blockPageName, blockPagesList]);

    if (expirationToken) {
        sessionStorage.removeItem(TOKEN);
        logout();
        return <Navigate to={EXPIRATIONTOKEN} />;
    }

    if (!tokenAuth) {
        return <Navigate to={SIGNIN} />;
    }

    return (
        <LayoutDefault>
            {checkValidate ? (
                <BlockPagesDefault validate={validate} />
            ) : (
                <Outlet />
            )}
        </LayoutDefault>
    );
}
